var _style, _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTourSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#F96C6C;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st2{display:inline;mask:url(#mask0_2295_19193_00000134247042281969456490000000792821887761198994_);}\r\n\t.st3{fill:#F96C6C;}\r\n\t.st4{display:inline;fill:#F96C6C;}\r\n\t.st5{fill:#3BFFE7;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "placement_layer",
    className: "st0"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 3.5,
    y: 2.4,
    width: 17,
    height: 19.1
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 3.5,
    y: 2.4,
    width: 17,
    height: 19.1,
    id: "mask0_2295_19193_00000134247042281969456490000000792821887761198994_",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F96C6C",
      filter: "url(#Adobe_OpacityMaskFilter)"
    },
    width: 24,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.3,21.5c-0.5,0-0.9-0.2-1.3-0.5s-0.5-0.8-0.5-1.3V6.3C3.5,5.8,3.7,5.4,4,5s0.8-0.5,1.3-0.5h1.4V3.2 c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5v1.3h7.6V3.1 c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2s0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5v1.4h1.4c0.5,0,0.9,0.2,1.3,0.5 s0.5,0.8,0.5,1.3v13.4c0,0.5-0.2,0.9-0.5,1.3s-0.8,0.5-1.3,0.5H5.3z M5.3,20h13.4c0.1,0,0.1,0,0.2-0.1c0.1-0.1,0.1-0.1,0.1-0.2 v-9.4H5v9.4c0,0.1,0,0.1,0.1,0.2C5.2,20,5.2,20,5.3,20z M5,8.8h14V6.3c0-0.1,0-0.1-0.1-0.2C18.8,6,18.8,6,18.7,6H5.3 C5.2,6,5.2,6,5.1,6.1C5,6.2,5,6.2,5,6.3V8.8z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.3,21.5c-0.5,0-0.9-0.2-1.3-0.5s-0.5-0.8-0.5-1.3V6.3C3.5,5.8,3.7,5.4,4,5c0.3-0.3,0.8-0.5,1.3-0.5h1.4V3.1 c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5v1.3h7.6V3.1c0-0.2,0.1-0.4,0.2-0.5 c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5v1.4h1.4c0.5,0,0.9,0.2,1.3,0.5c0.4,0.4,0.5,0.8,0.5,1.3 v13.4c0,0.5-0.2,0.9-0.5,1.3s-0.8,0.5-1.3,0.5H5.3z M5.3,20h13.4c0.1,0,0.1,0,0.2-0.1c0.1-0.1,0.1-0.1,0.1-0.2v-9.4H5v9.4 c0,0.1,0,0.1,0.1,0.2C5.2,20,5.2,20,5.3,20z M5,8.8h14V6.3c0-0.1,0-0.1-0.1-0.2C18.8,6,18.8,6,18.7,6H5.3C5.2,6,5.2,6,5.1,6.1 C5,6.2,5,6.2,5,6.3V8.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "tour"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M3.5,23.2V1.3c0-0.2,0.1-0.3,0.2-0.4C3.8,0.8,4,0.8,4.1,0.8c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4 v1.8h14.9c0.3,0,0.6,0.1,0.8,0.4c0.2,0.3,0.2,0.6,0.1,0.9l-1.6,4l1.6,4c0.1,0.3,0.1,0.6-0.1,0.9c-0.2,0.3-0.4,0.4-0.8,0.4H4.7v9.5 H3.5z M11.8,10.2c0.5,0,0.9-0.2,1.3-0.5c0.3-0.3,0.5-0.8,0.5-1.3c0-0.5-0.2-0.9-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5 c-0.5,0-0.9,0.2-1.3,0.5S10,8,10,8.5c0,0.5,0.2,0.9,0.5,1.3C10.9,10.1,11.3,10.2,11.8,10.2z M4.7,12.6h14.5l-1.6-4.1l1.6-4.1H4.7 V12.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourSm);
export default __webpack_public_path__ + "static/media/tour-sm.36c167987b599c753eff7d48f1b2b1f6.svg";
export { ForwardRef as ReactComponent };